import React from "react";
import { CustomerSection } from "../customersSection";
import VimeoEmbed from "../vimeo/vimeo";

const AmplificationStrategiesBanner = ({ title, description, clients }) => {
  return (
    <>
      <div className="conference-hero">
        <div className="container inner-content">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-7">
              <h1>{title}</h1>
              <h4 className="title-ext text-primary">{description}</h4>
            </div>{" "}
            <div className="col-lg-6 col-md-6 col-sm-5">
              {" "}
              <VimeoEmbed />
            </div>
          </div>
        </div>
      </div>
      <CustomerSection clients={clients} />
    </>
  );
};

export default AmplificationStrategiesBanner;
